
    // Import dependencies (handled by Vite)
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/ScrollTrigger';
    import Lenis from '@studio-freight/lenis';
    
    // Wait for everything to be loaded
    document.addEventListener('DOMContentLoaded', async () => {

      // Initialize audio manager and preload sounds
      console.log('Initializing audio manager...');
      
      if (window.audioManager) {
          console.log('AudioManager found, preloading sounds...');
          try {
              await audioManager.preloadGuitarSounds();
              console.log('All sounds preloaded successfully');
          } catch (error) {
              console.error('Error preloading sounds:', error);
          }
      } else {
          console.error('AudioManager not found!');
      }

      // Initialize GSAP plugins
      gsap.registerPlugin(ScrollTrigger);
      
      // Initialize Lenis smooth scroll
      const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
      });
      
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);
      
      // Handle theme initialization
      const urlParams = new URLSearchParams(window.location.search);
      const demoTheme = urlParams.get('theme');
      const isDemo = urlParams.get('demo');

      // Wait for theme switcher to be available
      let themeSwitcherCheckInterval = setInterval(() => {
        if (typeof themeSwitcher !== 'undefined') {
          clearInterval(themeSwitcherCheckInterval);
          
          // Apply theme from URL parameter if provided
          if (demoTheme) {
            themeSwitcher.switchTheme(demoTheme);
          }

          // Handle demo mode
          if (isDemo) {
            const floatingSwitcher = document.getElementById('floating-theme-switcher');
            if (floatingSwitcher) {
              floatingSwitcher.style.display = 'none';
            }
            
            // Notify parent window that iframe is ready
            if (window.parent !== window) {
              window.parent.postMessage({ type: 'IFRAME_READY' }, '*');
            }
          }
        }
      }, 100);

      // Listen for theme change messages from parent window (demo page)
      window.addEventListener('message', (event) => {
        if (event.data?.type === 'THEME_CHANGE' && typeof themeSwitcher !== 'undefined') {
          themeSwitcher.switchTheme(event.data.theme);

          // Apply custom colors if provided
          if (event.data.customColors) {
            Object.entries(event.data.customColors).forEach(([colorVar, colorValue]) => {
              document.documentElement.style.setProperty(colorVar, colorValue);
            });
          }
        }
      });
    });
  